import {withRouter} from 'react-router';

import type {ComponentType} from 'react';

export type LocationType<Q> = {
  query: Q;
  pathname: string;
  search: string;
  hash: string;
};

export type NavigateToLocationType = {
  readonly pathname: string;
  readonly search?: string;
  readonly hash?: string;
  readonly query?: Record<string, any>;
};

export type RouterType<Q> = {
  goBack: () => void;
  replace: (path: string | NavigateToLocationType) => void;
  push: (path: string | NavigateToLocationType) => void;
  location: LocationType<Q>;
  params: Record<string, string>;
  getCurrentLocation: () => LocationType<Q>;
  setRouteLeaveHook: (route: any, callback: () => string | void) => void;
  isActive: (path: string | NavigateToLocationType) => boolean;
};

export type WithRouterProps<
  Query extends Record<string, any>,
  Params extends Record<string, any>,
  Route extends Record<string, any>,
  RP
> = {
  location: LocationType<Query>;
  params: Params;
  route: Route & {
    path: string;
    component: any;
    query: Query;
    props: RP;
  };
  router: RouterType<Query>;
  routeParams: Params;
  routes: Array<{
    component: any;
    childRoutes: Array<any>;
    breadcrumb: any;
  }>;
};

/*
Apply the withRouter HOC and keep Component and prop types
*/

/* This should be used with components with exact Props objects - most of them */
export function withTypedRouter<Config extends Record<string, any>, WR>(
  WithTypedRouterWrappedComponent: ComponentType<Config & WR>
): ComponentType<Config> {
  // @ts-expect-error this worked in the past so the types must be OK
  return withRouter(WithTypedRouterWrappedComponent) as ComponentType<Config>;
}

type Diff<T, U> = Pick<T, Exclude<keyof T, keyof U>>;
/*  This should be used with components with inexact Props objects
    i.e. ReplaceableLink and other which sends props down */
export function withTypedRouterInexact<Config extends Record<string, any>, WR>(
  WithTypedRouterWrappedComponent: ComponentType<Config & WR>
): ComponentType<Diff<Config, WR>> {
  // @ts-expect-error this worked in the past so the types must be OK
  return withRouter(WithTypedRouterWrappedComponent) as ComponentType<
    Diff<Config, WR>
  >;
}
